export const SESSION_STORAGE_KEYS = {
  USER_SELECTED_LOCATIONS: 'yshUserSelectedLocations',
  IS_WIZARD_YETTEL_PETAK_MODAL_SEEN: 'yshIsWizardYettelPetakModalSeen',
  IS_PRIZE_MODAL_SEEN: 'yshIsPrizeModalSeen',
  IS_ENDGAME_MODAL_SEEN: 'yshIsEndGameModalSeen',
  IS_RESULTS_MODAL_SEEN: 'yshIsResultsModalSeen',
  IS_NEWSLETTER_MODAL_SEEN: 'yshIsNewsletterModalSeen',
  QUIZ_RESOURCE_LINK_PENDING: 'yshQuizResourceLinkPending'
};
